import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import { POUNDS } from "MODULES/parts/constants";
import { Stars } from "MODULES/shared/components/Stars/Stars";
import { AdditionalButtons } from "MODULES/shared/components/Forms/AppForm";
import { ADMIN, ROLE, USER } from "MODULES/users/constants";
import ImportPartsForm from "MODULES/parts/components/CreateImportParts/ImportPartsForm";
import Form from "./Form";

export function CreatePart({ open, close, currentUser }) {
  const initialValues = {
    weight_unit: POUNDS,
    esd: false,
    hazmat: false,
    bio_hazmat: false,
    llp: false
  };

  const [tierType, setTierType] = useState(null);
  const [importModalOpen, setImportModalOpen] = useState(false);

  const openImportModal = () => {
    close();
    setTimeout(() => {
      setImportModalOpen(true);
    }, 300);
  };

  const closeImportModal = () => setImportModalOpen(false);

  const handleSubmit = () => {
    close();
  };

  const isAdmin = currentUser && currentUser.get(ROLE) === ADMIN;
  return (
    <div>
      <Modal open={open} close={close}>
        <Header>
          <Close close={close} />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h4 className="modal-title">Add a Part</h4>
            <Stars
              size="fa-lg"
              tierType={tierType}
              style={{ marginRight: 15 }}
              updatePart={tier => setTierType(tier)}
              disabled={false}
            />
          </div>
        </Header>
        <Form
          close={close}
          initialValues={initialValues}
          tierType={tierType}
          onSubmit={handleSubmit}
        >
          {isAdmin && (
            <AdditionalButtons>
              <button
                type="button"
                className="btn btn-primary"
                onClick={openImportModal}
              >
                Import
              </button>
            </AdditionalButtons>
          )}
        </Form>
      </Modal>
      <Modal open={importModalOpen} close={closeImportModal}>
        <Header>
          <Close close={closeImportModal} />
          <h4 className="modal-title">Import New Parts CSV</h4>
        </Header>
        <ImportPartsForm close={closeImportModal} enableReinitialize />
      </Modal>
    </div>
  );
}

CreatePart.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  currentUser: PropTypes.shape({
    get: PropTypes.func.isRequired
  })
};

const mapStateToProps = state => ({
  currentUser: state.session.get(USER)
});

export default connect(mapStateToProps)(CreatePart);



// WEBPACK FOOTER //
// ./app/modules/parts/components/CreatePart/CreatePart.jsx